import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";

const milestones = [
  {
    year: "۱۳۹۰",
    title: "اخذ مجوز فعالیت",
    desc: "اخذ مجوز فعالیت از سازمان بورس و اوراق بهادار",
  },
  {
    year: "۱۳۹۱",
    title: "صندوق سهامی نوید انصار",
    desc: "آغاز فعالیت صندوق سهامی نوید انصار",
  },
  {
    year: "۱۳۹۲",
    title: "توسعه صندوق‌ها",
    desc: "آغاز فعالیت صندوق مختلط گنجینه مهر و صندوق سهامی بذر امیدآفرین",
  },
  {
    year: "۱۳۹۴",
    title: "صندوق درآمد ثابت",
    desc: "آغاز فعالیت صندوق درآمد ثابت امید انصار و گنجینه امید ایرانیان",
  },
  {
    year: "۱۳۹۶",
    title: "پذیرش در بورس",
    desc: "عرضه سهام تأمین سرمایه امید به عنوان نخستین شرکت تأمین سرمایه در بورس تهران و آغاز صندوق زرافشان امید ایرانیان",
  },
  {
    year: "۱۳۹۸",
    title: "صندوق ETF بذر",
    desc: "تبدیل صندوق بذر به صندوق قابل معامله (ETF)",
  },
  {
    year: "۱۴۰۳",
    title: "صندوق ETF آسان",
    desc: "پذیره‌نویسی و آغاز فعالیت صندوق ETF درآمد ثابت گنجینه مهر با نماد «آسان»",
  },
  {
    year: "۱۴۰۴",
    title: "نوآوری و فناوری",
    desc: "رونمایی از دستیار هوشمند «امیدیار»، سکوی تأمین مالی «امیدکراد» و سامانه خرید آسان",
  },
];

export const SectionHistory = () => {
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const lineColor = useColorModeValue("gray.200", "gray.600");
  const dotBg = useColorModeValue("brand.500", "brand.400");
  const yearBg = useColorModeValue("brand.50", "icon.bg");
  const yearColor = useColorModeValue("brand.600", "icon.svg");

  return (
    <Box>
      <Container maxW="container.lg">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              تاریخچه و دستاوردها
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              نقاط عطف مسیر ما
            </Text>
          </VStack>

          {/* Vertical Timeline */}
          <VStack spacing={0} align="stretch" position="relative">
            {/* Vertical line */}
            <Box
              position="absolute"
              right="11px"
              top="8px"
              bottom="8px"
              w="2px"
              bg={lineColor}
            />

            {milestones.map((m, i) => (
              <HStack key={i} spacing={4} align="flex-start" py={4}>
                {/* Dot */}
                <Box position="relative" zIndex={1} flexShrink={0}>
                  <Box
                    w="24px"
                    h="24px"
                    borderRadius="full"
                    bg={dotBg}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box w="10px" h="10px" borderRadius="full" bg="white" />
                  </Box>
                </Box>

                {/* Content */}
                <VStack align="flex-start" spacing={1} flex={1}>
                  <Box bg={yearBg} px={2.5} py={0.5} borderRadius="md">
                    <Text fontSize="xs" fontWeight="bold" color={yearColor}>
                      {m.year}
                    </Text>
                  </Box>
                  <Text fontWeight="bold" fontSize="sm" color={headingColor}>
                    {m.title}
                  </Text>
                  <Text fontSize="xs" color={textColor} lineHeight="1.7">
                    {m.desc}
                  </Text>
                </VStack>
              </HStack>
            ))}
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};
